import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpService } from '@services/http.service';
import { EndpointParams } from '@models/utils/endpoint-params';
import { PaymentLinkMemberSearch } from '@models/index';
import { PaymentCreateResponse } from '@models/buy/response/payment-create-response';
import { PaymentLinkBuy } from '@models/index';
import { CartSummary } from '@views/customer/cart/models';
import { fillCouponTypeNames } from '@views/customer/cart/helpers/cart-summary.helper';

@Injectable({
    providedIn: 'root'
})
export class RatesPaymentLinkService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    search(link: string): Observable<PaymentLinkMemberSearch> {
        return this.get(`payment-link/member?link=${encodeURIComponent(link)}`, this.defaultEndpointParams);
    }

    searchSummary(link: string): Observable<CartSummary> {
        return this.get(`payment-link/member/summary?link=${encodeURIComponent(link)}`, this.defaultEndpointParams).pipe(map(fillCouponTypeNames));
    }

    create(paymentLinkBuy: PaymentLinkBuy): Observable<PaymentCreateResponse> {
        return this.post('payment-link/member', this.defaultEndpointParams, paymentLinkBuy, this.noShowErrorNotification);
    }
}
